let idCount = 0;

function uniqueId(prefix) {
    // eslint-disable-next-line no-plusplus
    return `${(prefix == null ? '' : prefix) + ++idCount}`;
}

export function notify(handler, args) {
    // eslint-disable-next-line prefer-spread, no-unused-expressions
    handler && handler.apply(null, [].concat(args));
}

export function instanceId(component, suffix = '') {
    // eslint-disable-next-line no-unused-expressions
    component.__id || (component.__id = uniqueId('rw_'));
    return (component.props.id || component.__id) + suffix;
}

export function isFirstFocusedRender(component) {
    // eslint-disable-next-line no-return-assign
    return (
        component._firstFocus ||
        (component.state.focused && (component._firstFocus = true))
    );
}
